const apis = [
  {
    // 专家分页列表
    fn: 'getPageList',
    method: 'POST',
    url: '/api/jsExpertStore/getPageList',
    hideLoading: true
  },
  {
    // 添加专家
    fn: 'add',
    method: 'POST',
    url: '/api/jsExpertStore/add',
    hideLoading: true
  },
  {
    // 修改专家
    fn: 'update',
    method: 'POST',
    url: '/api/jsExpertStore/update',
    hideLoading: true
  },
  {
    // 删除专家
    fn: 'delete',
    method: 'POST',
    url: '/api/jsExpertStore/delete',
    hideLoading: true
  },
  {
    // 专家详情
    fn: 'info',
    method: 'GET',
    url: '/api/jsExpertStore/info',
    hideLoading: true
  }
]

export default apis
